export default __webpack_public_path__ + "static/media/Colombia.a89a3d88.png";